import React, {
  isValidElement,
  cloneElement,
  useLayoutEffect,
  useState,
} from 'react';
import PropTypes from 'prop-types';
const { map } = React.Children;

/* eslint-env browser */

/**
 * 
  <Orientation landscape={<A />} portrait={<B />} />
  <Orientation landscape={<A />} />
 */

const useOrientation = mediaQuery => {
  const [matches, setMatches] = useState(
    () => window.matchMedia(mediaQuery).matches,
  );

  useLayoutEffect(() => {
    const mediaQueryList = window.matchMedia(mediaQuery);
    const listener = e => setMatches(e.matches);
    mediaQueryList.addListener(listener);
    return () => mediaQueryList.removeListener(listener);
  }, [mediaQuery]);

  return matches;
};

const Orientation = props => {
  const { children, portrait, landscape } = props;

  if (!children && !portrait && !landscape)
    throw new Error(
      'Either provide children or a combo of lanscape and portrait',
    );

  const isLandscape = useOrientation('(orientation: landscape)');

  if (children)
    return map(children, c => {
      // ignore random <div/>s etc.
      if (!isValidElement(c) || typeof c.type === 'string') {
        return c;
      }
      return cloneElement(c, {
        isLandscape,
      });
    });

  return <>{isLandscape ? landscape : portrait}</>;
};

Orientation.propTypes = {
  portrait: PropTypes.element,
  landscape: PropTypes.element,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]),
};

Orientation.defaultProps = {
  children: null,
  portrait: null,
  landscape: null,
};

export default Orientation;
export { useOrientation };
